import { SEGMENT_COLORS, SEGMENT_LABELS, SEGMENTS } from '../../constants';
import type { Segment } from '../../types';

interface SegmentToggleProps {
  value: Segment;
  onChange: (segment: Segment) => void;
}

const SegmentToggle = ({ value, onChange }: SegmentToggleProps) => (
  <div className="toggle-group">
    {SEGMENTS.map((segment) => (
      <button
        key={segment}
        className={segment === value ? 'active' : ''}
        onClick={() => onChange(segment)}
        style={{
          borderColor: segment === value ? SEGMENT_COLORS[segment] : undefined
        }}
      >
        <span className="dot" style={{ background: SEGMENT_COLORS[segment] }} />
        {SEGMENT_LABELS[segment]}
      </button>
    ))}
  </div>
);

export default SegmentToggle;
